import React from "react";
import { Box, Typography } from "@mui/material";
import color from "../utils/Colors";

interface RatingCardProps {
  ratings: { name: string; score: number }[];
}

const TeacherRatingCard: React.FC<RatingCardProps> = ({ ratings }) => {
  return (
    <Box
      sx={{
        backgroundColor: color.firstColor,
        color: "white",
        borderRadius: "10px",
        padding: "20px",
        width: "300px",
        height: "350px",
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '6px',
          height: '20px',
        },
        '&::-webkit-scrollbar-track': {
          background: color.secondColor,
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: color.firstColor,
          border: 'solid 1px white',
          borderRadius: '10px',
        },
      }}
    >
      <Typography
        variant="h5"
        sx={{ marginBottom: "25px", fontWeight: "bold" }}
      >
        Teachers Rating Graph
      </Typography>
      {ratings.length === 0 ? (
        <Typography variant="body2">No teacher ratings yet.</Typography>
      ) : (
        ratings.map((rating, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <Typography
            sx={{
              color: "#d2abff",
              writingMode: "vertical-rl",
              textOrientation: "sideways",
              marginRight: "8px",
              fontSize:'10px',
            }}
          >
            {rating.name}
          </Typography>
          <Box
            sx={{
              backgroundColor: "#d2abff",
              height: "8px",
              width: `${rating.score}%`,
              borderRadius: "4px",
            }}
          />
        </Box>
      ))
      )}
    </Box>
  );
};

export default TeacherRatingCard;
